module.exports = __webpack_public_path__ + "static/img/Banner_LineFriend_MotorExpo.562ed84.jpg";